import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { CSidebar, CSidebarBrand, CSidebarNav, CSidebarToggler } from '@coreui/react'
import { AppSidebarNav } from './AppSidebarNav'
import goigilogo from 'src/assets/images/logo.png'
import goigibig from 'src/assets/images/logo.png'
import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'
import navigation from '../_nav'
import { SetSidebarVisibility } from 'src/Thunk/adminThunks'

const AppSidebar = () => {
  const dispatch = useDispatch()
  const {sidebarShow} = useSelector((state) => state.admin)
  const sidebarBrandStyle = {
    backgroundColor: '#fff', // Set the background color to gray
    padding: '0px', // Optional padding
  };

  return (
    <CSidebar
      position="fixed"
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        dispatch(SetSidebarVisibility(visible))
      }}
    >
      <CSidebarBrand className="d-none d-md-flex" to="/" style={sidebarBrandStyle}>
        <Link to='/dashboard' > <img className="sidebar-brand-full" src={goigibig} alt="Your Image" height={55}  /></Link>
        <Link to='/dashboard' ><img className="sidebar-brand-narrow" src={goigilogo} alt="Your Image" height={35} /> </Link>
      </CSidebarBrand>
      <CSidebarNav>
        <SimpleBar>
          <AppSidebarNav items={navigation} />
        </SimpleBar>
      </CSidebarNav>
      <CSidebarToggler
        className="d-none d-lg-flex"
        
      />
    </CSidebar>
  )
}

export default React.memo(AppSidebar)
